import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import {
  useGetVolunteersListQuery,
  useGetControllersListQuery,
} from "features/api/usersPermissionsManagement/usersPermissionsManagementApiSlice";
import {
  TabTypes,
  UsersPermissionsManagementTabConfig,
} from "./UsersPermissionsManagementTypes";
import { USERS_PERMISSIONS_MANAGEMENT_TABS } from "./UsersPermissionsManagementUtils";
import "./UsersPermissionsManagement.scss";
import { volunteersDataTable } from "./UsersPermissionsManagementComponents/volunteers/volunteerTypes";

const UsersPermissionsManagement = () => {
  const [selectedTab, setSelectedTab] = useState<TabTypes>(
    USERS_PERMISSIONS_MANAGEMENT_TABS[0].tabName
  );

  const { volunteersCount } = useGetVolunteersListQuery(
    { page: 1 },
    {
      selectFromResult: ({ data }: { data: volunteersDataTable }) => ({
        volunteersCount: data?.totalVolunteersCount,
      }),
    }
  );

  const { controllersCount } = useGetControllersListQuery(
    {},
    {
      selectFromResult: ({ data }) => ({
        controllersCount: data?.length,
      }),
    }
  );

  const navigate = useNavigate();
  const location = useLocation();

  const handleTabChange = (tabName: TabTypes) => {
    setSelectedTab(tabName);
    // change the url param as well
    navigate(`/control-center/users-permissions/${tabName}`);
  };

  useEffect(() => {
    // get the tab name from the url param
    const tabName = location.pathname.split("/").pop();
    if (tabName) {
      setSelectedTab(tabName as TabTypes);
    }
  }, [location.pathname]);

  const getTabTitle = ({ tabName, tabTitle }) => {
    if (tabName === ("volunteers" as TabTypes) && volunteersCount) {
      return `${tabTitle} (${volunteersCount})`;
    }
    if (tabName === ("controllers" as TabTypes) && controllersCount) {
      return `${tabTitle} (${controllersCount})`;
    }
    return "";
  };

  return (
    <div className="users-permissions-management-page">
      <Tabs
        id="controlled-tab-example"
        activeKey={selectedTab}
        onSelect={handleTabChange}
        className="mb-3 tabs-container"
      >
        {USERS_PERMISSIONS_MANAGEMENT_TABS.map(
          (tabObject: UsersPermissionsManagementTabConfig) => {
            const SelectedTab = tabObject.tabComponent;
            const { tabName } = tabObject;
            return (
              <Tab
                eventKey={tabName}
                title={getTabTitle(tabObject)}
                key={tabObject.tabName}
              >
                <SelectedTab />
              </Tab>
            );
          }
        )}
      </Tabs>
    </div>
  );
};

export default UsersPermissionsManagement;
